import React, { useState } from 'react';
import Select from 'antd/lib/select';
import { maskCurrency, unmaskCurrency } from './currencyMask';

type AmountField = 'valueMin' | 'valueMax';

interface ValueFilterFieldsProps {
  col: React.ComponentType<any>;
  setFieldValue: (field: string, value: any) => void;
}

const BREAKPOINTS = { xs: {flex: '100%'}, sm: {flex: '50%'}, md: {flex: '40%'}, lg: {flex: '20%'}, xl: {flex: '10%'} };

const FIELD_OPTIONS = [
  { value: '', label: 'Tipo valor' },
  { value: 'gross', label: 'Valor bruto' },
  { value: 'liquid', label: 'Valor líquido' },
];

const OPERATOR_OPTIONS = [
  { value: '', label: 'Comparação' },
  { value: 'greater', label: 'Maior ou igual a' },
  { value: 'less', label: 'Menor ou igual a' },
  { value: 'between', label: 'Entre' },
];

const AMOUNTS: { field: AmountField; operators: string[]; betweenLabel: string }[] = [
  { field: 'valueMin', operators: ['greater', 'between'], betweenLabel: 'Valor de (R$)' },
  { field: 'valueMax', operators: ['less', 'between'], betweenLabel: 'Valor até (R$)' },
];

const ValueFilterFields: React.FC<ValueFilterFieldsProps> = ({ col: Col, setFieldValue }) => {
  const [operator, setOperator] = useState<string>('');
  const [amounts, setAmounts] = useState<Record<AmountField, string>>({ valueMin: '', valueMax: '' });

  const changeAmount = (field: AmountField, rawValue: string): void => {
    const masked = maskCurrency(rawValue);
    setAmounts(current => ({ ...current, [field]: masked }));
    setFieldValue(field, unmaskCurrency(masked));
  };

  const handleOperator = (value: string): void => {
    setOperator(value);
    setFieldValue('valueOperator', value || null);
    AMOUNTS.filter(({ operators }) => !operators.includes(value))
      .forEach(({ field }) => changeAmount(field, ''));
  };

  return (
    <>
      <Col {...BREAKPOINTS}>
        <Select defaultValue="" style={{width: '100%'}} options={FIELD_OPTIONS}
                onChange={(value: string) => setFieldValue('valueField', value || null)}/>
      </Col>

      <Col {...BREAKPOINTS}>
        <Select defaultValue="" style={{width: '100%'}} options={OPERATOR_OPTIONS} onChange={handleOperator}/>
      </Col>

      {AMOUNTS.filter(({ operators }) => operators.includes(operator)).map(({ field, betweenLabel }) => (
        <Col key={field} {...BREAKPOINTS}>
          <input type="text" inputMode="numeric" value={amounts[field]}
                 placeholder={operator === 'between' ? betweenLabel : 'Valor (R$)'}
                 onChange={event => changeAmount(field, event.target.value)}/>
        </Col>
      ))}
    </>
  );
};

export default ValueFilterFields;
